import { render, staticRenderFns } from "./ProductHead.vue?vue&type=template&id=286a972d&scoped=true&"
import script from "./ProductHead.vue?vue&type=script&lang=js&"
export * from "./ProductHead.vue?vue&type=script&lang=js&"
import style0 from "./ProductHead.vue?vue&type=style&index=0&id=286a972d&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286a972d",
  null
  
)

export default component.exports